module.exports = __webpack_public_path__ + "static/img/basketballTraining.de6eae4d.svg";